/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import router from "@/router/index";
import { ElMessage } from "element-plus";

const TOKEN_INVALID = "Token认证失败，请重新登陆";
const NETWORK_ERROR = "网络请求异常，请稍后重试";

// 创建axios实例对象，添加全局配置
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    // timeout: 10000,
    timeout: 0,
});

// 响应拦截

let elMsg = null;

function multipleElMessage(type,message){ // 防止多个message 同时弹出
    if(!elMsg){
        elMsg = ElMessage({
            type,
            message: message,
            onClose(){
                elMsg = null
            }
        });
    }
}

service.interceptors.response.use((res) => {
    const { code, data, msg } = res.data;

    if (code === 200) {
        return res.data;
    } else if(res.status===200&&res.config.download) {
        return res.data
    } else if (code === 401) {
        multipleElMessage('error',TOKEN_INVALID);
        setTimeout(() => {
            router.push("/login");
        }, 1000);
        return Promise.reject(TOKEN_INVALID);
    } else {
        multipleElMessage('error',msg||NETWORK_ERROR);
        return Promise.reject(NETWORK_ERROR);
    }
});

/**
 * 请求核心函数
 * @param {*} options 请求配置
 */
const request = (options) => {
    console.log(options);
    
    return new Promise((resolve, reject) => {
        let token = localStorage.getItem('token')
        options.headers= {
            authorization:token,
            ...options.headers,

        }
        options.method = options.method || "get";
        if (options.method.toLowerCase() === "get") {
            options.params = options.data;
        }
        service(options)
            .then((res,options) => resolve(res,))
            .catch((error) => reject(error));
    });
};

export default request;
